import { render, staticRenderFns } from "./addpersonCast.vue?vue&type=template&id=dbe74808&"
import script from "./addpersonCast.vue?vue&type=script&lang=js&"
export * from "./addpersonCast.vue?vue&type=script&lang=js&"
import style0 from "./addpersonCast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbe74808')) {
      api.createRecord('dbe74808', component.options)
    } else {
      api.reload('dbe74808', component.options)
    }
    module.hot.accept("./addpersonCast.vue?vue&type=template&id=dbe74808&", function () {
      api.rerender('dbe74808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addpersonCast.vue"
export default component.exports